function isVariantLabel(v) {
  return typeof v === "string" || Array.isArray(v);
}
export {
  isVariantLabel
};
//# sourceMappingURL=is-variant-label.js.map
